/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.7.1.0 (NJsonSchema v9.6.0.0) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';
import { HydrogenAppConfigService } from '../host.config.service';
export const API_BASE_URL = new InjectionToken('API_BASE_URL');

@Injectable()
export class ScheduledActionsApiService {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configSvc: HydrogenAppConfigService, @Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = configSvc.config.serviceUrl.scheduledactions; 
    }

    getScheduledActions(search: ScheduledActionsSearch): Observable<ReportScheduledActionsData> {
        let url_ = this.baseUrl + "/api/scheduledActions/many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(search);

        let options_ = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetScheduledActions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetScheduledActions(response_);
                } catch (e) {
                    return <Observable<ReportScheduledActionsData>><any>Observable.throw(e);
                }
            } else
                return <Observable<ReportScheduledActionsData>><any>Observable.throw(response_);
        });
    }

    protected processGetScheduledActions(response: Response): Observable<ReportScheduledActionsData> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReportScheduledActionsData.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ReportScheduledActionsData>(<any>null);
    }

    getScheduledActionByDeviceOrGroupId(id: string): Observable<ScheduledAction[]> {
        let url_ = this.baseUrl + "/api/scheduledActions/DeviceOrGroupId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetScheduledActionByDeviceOrGroupId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetScheduledActionByDeviceOrGroupId(response_);
                } catch (e) {
                    return <Observable<ScheduledAction[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ScheduledAction[]>><any>Observable.throw(response_);
        });
    }

    protected processGetScheduledActionByDeviceOrGroupId(response: Response): Observable<ScheduledAction[]> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ScheduledAction.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ScheduledAction[]>(<any>null);
    }

    getScheduledActionById(id: string): Observable<ScheduledAction> {
        let url_ = this.baseUrl + "/api/scheduledActions/id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetScheduledActionById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetScheduledActionById(response_);
                } catch (e) {
                    return <Observable<ScheduledAction>><any>Observable.throw(e);
                }
            } else
                return <Observable<ScheduledAction>><any>Observable.throw(response_);
        });
    }

    protected processGetScheduledActionById(response: Response): Observable<ScheduledAction> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ScheduledAction.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ScheduledAction>(<any>null);
    }

    createScheduledAction(request: ScheduledActionRequest): Observable<ScheduledAction> {
        let url_ = this.baseUrl + "/api/scheduledActions/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processCreateScheduledAction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateScheduledAction(response_);
                } catch (e) {
                    return <Observable<ScheduledAction>><any>Observable.throw(e);
                }
            } else
                return <Observable<ScheduledAction>><any>Observable.throw(response_);
        });
    }

    protected processCreateScheduledAction(response: Response): Observable<ScheduledAction> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ScheduledAction.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ScheduledAction>(<any>null);
    }

    deleteScheduledAction(id: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/scheduledActions/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processDeleteScheduledAction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteScheduledAction(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processDeleteScheduledAction(response: Response): Observable<boolean> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    updateScheduledAction(request: ScheduledAction): Observable<ScheduledAction> {
        let url_ = this.baseUrl + "/api/scheduledActions/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processUpdateScheduledAction(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateScheduledAction(response_);
                } catch (e) {
                    return <Observable<ScheduledAction>><any>Observable.throw(e);
                }
            } else
                return <Observable<ScheduledAction>><any>Observable.throw(response_);
        });
    }

    protected processUpdateScheduledAction(response: Response): Observable<ScheduledAction> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ScheduledAction.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ScheduledAction>(<any>null);
    }
}

export class ScheduledActionsSearch implements IScheduledActionsSearch {
    accountId?: string;
    deviceId?: string;
    groupId?: string;
    deviceModelType?: string;
    sortCriteria?: string;
    sortDirection?: string;
    page?: number;
    pageSize?: number;

    constructor(data?: IScheduledActionsSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
            this.deviceId = data["DeviceId"] !== undefined ? data["DeviceId"] : <any>null;
            this.groupId = data["GroupId"] !== undefined ? data["GroupId"] : <any>null;
            this.deviceModelType = data["DeviceModelType"] !== undefined ? data["DeviceModelType"] : <any>null;
            this.sortCriteria = data["SortCriteria"] !== undefined ? data["SortCriteria"] : <any>null;
            this.sortDirection = data["SortDirection"] !== undefined ? data["SortDirection"] : <any>null;
            this.page = data["Page"] !== undefined ? data["Page"] : <any>null;
            this.pageSize = data["PageSize"] !== undefined ? data["PageSize"] : <any>null;
        }
    }

    static fromJS(data: any): ScheduledActionsSearch {
        let result = new ScheduledActionsSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["DeviceId"] = this.deviceId !== undefined ? this.deviceId : <any>null;
        data["GroupId"] = this.groupId !== undefined ? this.groupId : <any>null;
        data["DeviceModelType"] = this.deviceModelType !== undefined ? this.deviceModelType : <any>null;
        data["SortCriteria"] = this.sortCriteria !== undefined ? this.sortCriteria : <any>null;
        data["SortDirection"] = this.sortDirection !== undefined ? this.sortDirection : <any>null;
        data["Page"] = this.page !== undefined ? this.page : <any>null;
        data["PageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        return data;
    }
}

export interface IScheduledActionsSearch {
    accountId?: string;
    deviceId?: string;
    groupId?: string;
    deviceModelType?: string;
    sortCriteria?: string;
    sortDirection?: string;
    page?: number;
    pageSize?: number;
}

export class ReportScheduledActionsData implements IReportScheduledActionsData {
    totalScheduledActions: number;
    scheduledActions?: ScheduledAction[];

    constructor(data?: IReportScheduledActionsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalScheduledActions = data["totalScheduledActions"] !== undefined ? data["totalScheduledActions"] : <any>null;
            if (data["scheduledActions"] && data["scheduledActions"].constructor === Array) {
                this.scheduledActions = [];
                for (let item of data["scheduledActions"])
                    this.scheduledActions.push(ScheduledAction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportScheduledActionsData {
        let result = new ReportScheduledActionsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalScheduledActions"] = this.totalScheduledActions !== undefined ? this.totalScheduledActions : <any>null;
        if (this.scheduledActions && this.scheduledActions.constructor === Array) {
            data["scheduledActions"] = [];
            for (let item of this.scheduledActions)
                data["scheduledActions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportScheduledActionsData {
    totalScheduledActions: number;
    scheduledActions?: ScheduledAction[];
}

export class ScheduledAction implements IScheduledAction {
    id: string;
    accountId: string;
    objectId?: string;
    objectName?: string;
    objectType: ObjectType;
    action?: string;
    deviceModelType?: string;
    sequenceNumber?: number;
    recurrencePatternType: RecurrenceType;
    recurrencePatternValue?: string[];
    scheduledInUTC?: Date;
    lastRan?: Date;
    deliveryState: DeliveryState;
    isScheduledSuccess?: boolean;
    created: Date;
    lastModified?: Date;
    lastModifiedBy?: string;
    startDate: Date;
    endDate?: Date;
    fileInfo?: FileInfo;
    popReceipt?: string;

    constructor(data?: IScheduledAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
            this.objectId = data["ObjectId"] !== undefined ? data["ObjectId"] : <any>null;
            this.objectName = data["ObjectName"] !== undefined ? data["ObjectName"] : <any>null;
            this.objectType = data["ObjectType"] !== undefined ? data["ObjectType"] : <any>null;
            this.action = data["Action"] !== undefined ? data["Action"] : <any>null;
            this.deviceModelType = data["DeviceModelType"] !== undefined ? data["DeviceModelType"] : <any>null;
            this.sequenceNumber = data["SequenceNumber"] !== undefined ? data["SequenceNumber"] : <any>null;
            this.recurrencePatternType = data["RecurrencePatternType"] !== undefined ? data["RecurrencePatternType"] : <any>null;
            if (data["RecurrencePatternValue"] && data["RecurrencePatternValue"].constructor === Array) {
                this.recurrencePatternValue = [];
                for (let item of data["RecurrencePatternValue"])
                    this.recurrencePatternValue.push(item);
            }
            this.scheduledInUTC = data["ScheduledInUTC"] ? new Date(data["ScheduledInUTC"].toString()) : <any>null;
            this.lastRan = data["LastRan"] ? new Date(data["LastRan"].toString()) : <any>null;
            this.deliveryState = data["DeliveryState"] !== undefined ? data["DeliveryState"] : <any>null;
            this.isScheduledSuccess = data["isScheduledSuccess"] !== undefined ? data["isScheduledSuccess"] : <any>null;
            this.created = data["Created"] ? new Date(data["Created"].toString()) : <any>null;
            this.lastModified = data["LastModified"] ? new Date(data["LastModified"].toString()) : <any>null;
            this.lastModifiedBy = data["LastModifiedBy"] !== undefined ? data["LastModifiedBy"] : <any>null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : <any>null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : <any>null;
            this.fileInfo = data["FileInfo"] ? FileInfo.fromJS(data["FileInfo"]) : <any>null;
            this.popReceipt = data["PopReceipt"] !== undefined ? data["PopReceipt"] : <any>null;
        }
    }

    static fromJS(data: any): ScheduledAction {
        let result = new ScheduledAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["ObjectId"] = this.objectId !== undefined ? this.objectId : <any>null;
        data["ObjectName"] = this.objectName !== undefined ? this.objectName : <any>null;
        data["ObjectType"] = this.objectType !== undefined ? this.objectType : <any>null;
        data["Action"] = this.action !== undefined ? this.action : <any>null;
        data["DeviceModelType"] = this.deviceModelType !== undefined ? this.deviceModelType : <any>null;
        data["SequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : <any>null;
        data["RecurrencePatternType"] = this.recurrencePatternType !== undefined ? this.recurrencePatternType : <any>null;
        if (this.recurrencePatternValue && this.recurrencePatternValue.constructor === Array) {
            data["RecurrencePatternValue"] = [];
            for (let item of this.recurrencePatternValue)
                data["RecurrencePatternValue"].push(item);
        }
        data["ScheduledInUTC"] = this.scheduledInUTC ? this.scheduledInUTC.toISOString() : <any>null;
        data["LastRan"] = this.lastRan ? this.lastRan.toISOString() : <any>null;
        data["DeliveryState"] = this.deliveryState !== undefined ? this.deliveryState : <any>null;
        data["isScheduledSuccess"] = this.isScheduledSuccess !== undefined ? this.isScheduledSuccess : <any>null;
        data["Created"] = this.created ? this.created.toISOString() : <any>null;
        data["LastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>null;
        data["LastModifiedBy"] = this.lastModifiedBy !== undefined ? this.lastModifiedBy : <any>null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["FileInfo"] = this.fileInfo ? this.fileInfo.toJSON() : <any>null;
        data["PopReceipt"] = this.popReceipt !== undefined ? this.popReceipt : <any>null;
        return data;
    }
}

export interface IScheduledAction {
    id: string;
    accountId: string;
    objectId?: string;
    objectName?: string;
    objectType: ObjectType;
    action?: string;
    deviceModelType?: string;
    sequenceNumber?: number;
    recurrencePatternType: RecurrenceType;
    recurrencePatternValue?: string[];
    scheduledInUTC?: Date;
    lastRan?: Date;
    deliveryState: DeliveryState;
    isScheduledSuccess?: boolean;
    created: Date;
    lastModified?: Date;
    lastModifiedBy?: string;
    startDate: Date;
    endDate?: Date;
    fileInfo?: FileInfo;
    popReceipt?: string;
}

export enum ObjectType {
    Device = <any>"Device",
    Group = <any>"Group",
    License = <any>"License",
    User = <any>"User",
    Policy = <any>"Policy",
}

export enum RecurrenceType {
    Never = <any>"Never",
    Daily = <any>"Daily",
    Weekly = <any>"Weekly",
    Monthly = <any>"Monthly",
}

export enum DeliveryState {
    Pending = <any>"Pending",
    Delivered = <any>"Delivered",
}

export class FileInfo implements IFileInfo {
    slotId?: number;
    fileId?: string;
    fileName?: string;
    version?: string;

    constructor(data?: IFileInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.slotId = data["SlotId"] !== undefined ? data["SlotId"] : <any>null;
            this.fileId = data["FileId"] !== undefined ? data["FileId"] : <any>null;
            this.fileName = data["FileName"] !== undefined ? data["FileName"] : <any>null;
            this.version = data["Version"] !== undefined ? data["Version"] : <any>null;
        }
    }

    static fromJS(data: any): FileInfo {
        let result = new FileInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SlotId"] = this.slotId !== undefined ? this.slotId : <any>null;
        data["FileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        data["FileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["Version"] = this.version !== undefined ? this.version : <any>null;
        return data;
    }
}

export interface IFileInfo {
    slotId?: number;
    fileId?: string;
    fileName?: string;
    version?: string;
}

export class CustomError implements ICustomError {
    severity: SeverityEnum;
    statusCode: HttpStatusCode;
    correlationId?: string;
    message?: string;
    exceptionType?: string;

    constructor(data?: ICustomError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.severity = data["Severity"] !== undefined ? data["Severity"] : <any>null;
            this.statusCode = data["StatusCode"] !== undefined ? data["StatusCode"] : <any>null;
            this.correlationId = data["CorrelationId"] !== undefined ? data["CorrelationId"] : <any>null;
            this.message = data["Message"] !== undefined ? data["Message"] : <any>null;
            this.exceptionType = data["ExceptionType"] !== undefined ? data["ExceptionType"] : <any>null;
        }
    }

    static fromJS(data: any): CustomError {
        let result = new CustomError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Severity"] = this.severity !== undefined ? this.severity : <any>null;
        data["StatusCode"] = this.statusCode !== undefined ? this.statusCode : <any>null;
        data["CorrelationId"] = this.correlationId !== undefined ? this.correlationId : <any>null;
        data["Message"] = this.message !== undefined ? this.message : <any>null;
        data["ExceptionType"] = this.exceptionType !== undefined ? this.exceptionType : <any>null;
        return data;
    }
}

export interface ICustomError {
    severity: SeverityEnum;
    statusCode: HttpStatusCode;
    correlationId?: string;
    message?: string;
    exceptionType?: string;
}

export enum SeverityEnum {
    None = 0,
    Warning = 1,
    Error = 2,
    Exception = 3,
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultipleChoices = 300,
    Ambiguous = 300,
    MovedPermanently = 301,
    Moved = 301,
    Found = 302,
    Redirect = 302,
    SeeOther = 303,
    RedirectMethod = 303,
    NotModified = 304,
    UseProxy = 305,
    Unused = 306,
    TemporaryRedirect = 307,
    RedirectKeepVerb = 307,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    NotAcceptable = 406,
    ProxyAuthenticationRequired = 407,
    RequestTimeout = 408,
    Conflict = 409,
    Gone = 410,
    LengthRequired = 411,
    PreconditionFailed = 412,
    RequestEntityTooLarge = 413,
    RequestUriTooLong = 414,
    UnsupportedMediaType = 415,
    RequestedRangeNotSatisfiable = 416,
    ExpectationFailed = 417,
    UpgradeRequired = 426,
    InternalServerError = 500,
    NotImplemented = 501,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    HttpVersionNotSupported = 505,
}

export class ScheduledActionRequest implements IScheduledActionRequest {
    scheduledAction?: ScheduledAction;
    activityLogs?: ActivityLog[];

    constructor(data?: IScheduledActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.scheduledAction = data["ScheduledAction"] ? ScheduledAction.fromJS(data["ScheduledAction"]) : <any>null;
            if (data["activityLogs"] && data["activityLogs"].constructor === Array) {
                this.activityLogs = [];
                for (let item of data["activityLogs"])
                    this.activityLogs.push(ActivityLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduledActionRequest {
        let result = new ScheduledActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ScheduledAction"] = this.scheduledAction ? this.scheduledAction.toJSON() : <any>null;
        if (this.activityLogs && this.activityLogs.constructor === Array) {
            data["activityLogs"] = [];
            for (let item of this.activityLogs)
                data["activityLogs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScheduledActionRequest {
    scheduledAction?: ScheduledAction;
    activityLogs?: ActivityLog[];
}

export class ActivityLog implements IActivityLog {
    id: string;
    accountId?: string;
    objectId?: string;
    objectName?: string;
    deviceModelType?: string;
    created: Date;
    correlationId: string;
    userId?: string;
    userName?: string;
    logType: ActivityLogType;
    targetObject?: string;
    property?: string;
    originalValue?: any;
    updatedValue?: any;
    actualValue?: any;
    displayedValue?: string;
    snapshottedObject?: any;

    constructor(data?: IActivityLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : <any>null;
            this.objectId = data["ObjectId"] !== undefined ? data["ObjectId"] : <any>null;
            this.objectName = data["ObjectName"] !== undefined ? data["ObjectName"] : <any>null;
            this.deviceModelType = data["DeviceModelType"] !== undefined ? data["DeviceModelType"] : <any>null;
            this.created = data["Created"] ? new Date(data["Created"].toString()) : <any>null;
            this.correlationId = data["CorrelationId"] !== undefined ? data["CorrelationId"] : <any>null;
            this.userId = data["UserId"] !== undefined ? data["UserId"] : <any>null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : <any>null;
            this.logType = data["LogType"] !== undefined ? data["LogType"] : <any>null;
            this.targetObject = data["TargetObject"] !== undefined ? data["TargetObject"] : <any>null;
            this.property = data["Property"] !== undefined ? data["Property"] : <any>null;
            this.originalValue = data["OriginalValue"] !== undefined ? data["OriginalValue"] : <any>null;
            this.updatedValue = data["UpdatedValue"] !== undefined ? data["UpdatedValue"] : <any>null;
            this.actualValue = data["ActualValue"] !== undefined ? data["ActualValue"] : <any>null;
            this.displayedValue = data["DisplayedValue"] !== undefined ? data["DisplayedValue"] : <any>null;
            this.snapshottedObject = data["SnapshottedObject"] !== undefined ? data["SnapshottedObject"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityLog {
        let result = new ActivityLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["AccountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["ObjectId"] = this.objectId !== undefined ? this.objectId : <any>null;
        data["ObjectName"] = this.objectName !== undefined ? this.objectName : <any>null;
        data["DeviceModelType"] = this.deviceModelType !== undefined ? this.deviceModelType : <any>null;
        data["Created"] = this.created ? this.created.toISOString() : <any>null;
        data["CorrelationId"] = this.correlationId !== undefined ? this.correlationId : <any>null;
        data["UserId"] = this.userId !== undefined ? this.userId : <any>null;
        data["UserName"] = this.userName !== undefined ? this.userName : <any>null;
        data["LogType"] = this.logType !== undefined ? this.logType : <any>null;
        data["TargetObject"] = this.targetObject !== undefined ? this.targetObject : <any>null;
        data["Property"] = this.property !== undefined ? this.property : <any>null;
        data["OriginalValue"] = this.originalValue !== undefined ? this.originalValue : <any>null;
        data["UpdatedValue"] = this.updatedValue !== undefined ? this.updatedValue : <any>null;
        data["ActualValue"] = this.actualValue !== undefined ? this.actualValue : <any>null;
        data["DisplayedValue"] = this.displayedValue !== undefined ? this.displayedValue : <any>null;
        data["SnapshottedObject"] = this.snapshottedObject !== undefined ? this.snapshottedObject : <any>null;
        return data;
    }
}

export interface IActivityLog {
    id: string;
    accountId?: string;
    objectId?: string;
    objectName?: string;
    deviceModelType?: string;
    created: Date;
    correlationId: string;
    userId?: string;
    userName?: string;
    logType: ActivityLogType;
    targetObject?: string;
    property?: string;
    originalValue?: any;
    updatedValue?: any;
    actualValue?: any;
    displayedValue?: string;
    snapshottedObject?: any;
}

export enum ActivityLogType {
    Device = 0,
    Group = 1,
    License = 2,
    Firmware = 3,
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return Observable.throw(result);
    else
        return Observable.throw(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        let reader = new FileReader();
        reader.onload = function () {
            observer.next(this.result);
            observer.complete();
        }
        reader.readAsText(blob);
    });
}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/Crestron.HydrogenAPI.ScheduledActionsApi.service.ts